import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import { Avatar } from '~/UIKit';
import { getInitials } from '~/Helpers/String.helper';
import { IconButton } from '@mui/material/';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ITrainer } from '~/Models/DTO/Trainer.models';
import { CHARCOAL_GREY, WHITE } from '~/Constants/Colors.constants';
import { FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { BOX_SHADOW_TOOLTIP } from '~/Constants/CSS.constants';

const styles = makeStyles(() => ({
  avatarContainer: {
    padding: 3,
    '&:hover': {
      zIndex: 1,
    },
    '&:not(:first-of-type)': {
      marginLeft: -15,
    },
  },
  avatar: {
    border: `1px solid ${WHITE}`,
  },
  avatarTooltip: {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: WHITE,
      color: CHARCOAL_GREY,
      fontSize: FONT_SIZE_SMALLISH,
      boxShadow: BOX_SHADOW_TOOLTIP,
    },
    [`&[data-popper-placement*="top"] .${tooltipClasses.tooltipPlacementTop}`]: {
      marginBottom: '5px',
    },
  },
}));

export const TrainerAvatar = ({
  trainer,
  showTooltip,
}: {
  trainer: ITrainer;
  showTooltip?: boolean;
}) => {
  const { classes } = styles();
  if (!trainer) {
    return null;
  }

  return (
    <Tooltip
      title={showTooltip ? trainer.name : ''}
      placement="top"
      classes={{ popper: classes.avatarTooltip }}
      disableInteractive
    >
      <IconButton className={classes.avatarContainer} size="small">
        {trainer.imageUrl ? (
          <Avatar src={trainer.imageUrl} className={classes.avatar} />
        ) : (
          <Avatar className={classes.avatar}>
            {getInitials(trainer.firstName, trainer.lastName)}
          </Avatar>
        )}
      </IconButton>
    </Tooltip>
  );
};
